import { createContext } from "react";

export const LookContext = createContext({});